import {percentChance} from '../../helpers/numbers-helper.js'
import {randomFromArray} from '../../helpers/random-from-array.js'
export function getBotObviousOpportunityDecision(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //% chance that we'll look for an obvious oppportunity
  if (!percentChance(casterModel.personalityObviousOpportunityRating) ) {
    //If roll fails, stop here
    return null;
  }

  //-----------------------------------------------------------------------------------------
  //Case 1: Look my moves that have positive damage multipliers for status TODO: because someday might have negative multipliers
  const decisionMatchesWithPositiveMultipliers = casterActions.filter(action => {
    //Find actions that have `statusMultiplayer` as the formatted array
    return Array.isArray(action.statusMultiplier) &&  action.statusMultiplier[1] > 0;
  }).filter(action => {
    //TODO: This bit assumes a) it's an offensive attack and b) we are only accepting one target. This is enough for now
    //Now filter for only my actions that have a valid target
    return enemyCombatants.find(enemyModel => enemyModel.status === action.statusMultiplier[0])
  }).map(action => {
    //Create a formatted decision model for returning (will choose one of the results randomly)
    return {
      actionModel: action,
      casterModel: casterModel,
      targetModels: [ //Same operation as above. Need a copy of the target Model
        enemyCombatants.find(enemyModel => enemyModel.status === action.statusMultiplier[0])
      ]
    }
  });
  //Return one of our status weakness matches randomly
  if (decisionMatchesWithPositiveMultipliers.length) {
    return randomFromArray(decisionMatchesWithPositiveMultipliers)
  }
  //-----------------------------------------------------------------------------------------


  //default to no decision
  return null;
}

/*
Should return:
 return {
  actionModel: {},
  casterModel,
  targetModels: [{}, {}]
 }
*/


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-bot-obvious-opportunity-decision.js